import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { manageFootballCompetitionService } from "../../../../../commons";
import { EnsueCollection } from "../../../../../ensue-react-system/utilities/ensue-collection";
import { StatusEnum } from "../../../../../commons/enums/status-enum";
import { ManageFootballTeam } from "../../../../../commons/models/football/admin/manage-football-team";

export interface IManageCompetitionSeasonAvailableTeamsState {
  competitionSeasonAvailableTeams: EnsueCollection<ManageFootballTeam>;
  competitionSeasonAvailableTeamsStatus: StatusEnum;
}

export interface IManageCompetitionAvailableTeamsOption {
  competitionId: number;
  seasonId: number;
  urlParams?: {
    hostTeamId?: number;
    page?: number;
    perPage?: number;
    sort?: string;
    sortOrder?: string;
    status?: string;
    name?: string;
  };
}

const initialState: IManageCompetitionSeasonAvailableTeamsState = {
  competitionSeasonAvailableTeams: new EnsueCollection<ManageFootballTeam>(),
  competitionSeasonAvailableTeamsStatus: StatusEnum.Idle,
};

export const fetchCompetitionSeasonAvailableTeams = createAsyncThunk(
  "manage/competitionSeasonAvailableTeams",
  async (options: IManageCompetitionAvailableTeamsOption, thunkAPI) => {
    try {
      const competitionAvailableTeams = await manageFootballCompetitionService.getAvailableTeamList(
        options.competitionId,
        options.seasonId,
        options.urlParams
      );
      return competitionAvailableTeams;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageCompetitionSeasonAvailableTeamsSlice = createSlice({
  name: "competitionSeasonAvailableTeams",
  initialState: initialState,
  reducers: {
    cleanUpCompetitionSeasonAvailableTeams(state) {
      state.competitionSeasonAvailableTeams = new EnsueCollection<ManageFootballTeam>();
      state.competitionSeasonAvailableTeamsStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchCompetitionSeasonAvailableTeams.pending, (state) => {
        state.competitionSeasonAvailableTeamsStatus = StatusEnum.Loading;
      })
      .addCase(
        fetchCompetitionSeasonAvailableTeams.fulfilled,
        (state, action: PayloadAction<EnsueCollection<ManageFootballTeam>>) => {
          state.competitionSeasonAvailableTeamsStatus = StatusEnum.Succeeded;
          state.competitionSeasonAvailableTeams = action.payload;
        }
      )
      .addCase(fetchCompetitionSeasonAvailableTeams.rejected, (state) => {
        state.competitionSeasonAvailableTeamsStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpCompetitionSeasonAvailableTeams } = manageCompetitionSeasonAvailableTeamsSlice.actions;
export default manageCompetitionSeasonAvailableTeamsSlice.reducer;
